export function PreloadPage() {
  return <div className="grid h-[100svh] place-items-center opacity-50">Preload Placeholder</div>;
}
